import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import InputBox from '../../components/Modal/InputBox';
import ModalButtons from '../../components/Modal/ModalButtons';
import DeleteModalSkeleton from '../../components/Skeletons/DeleteModalSkeleton';

const DeleteFolderModal = ({ loading, data }) => {
	const { t } = useTranslation();
	const { deleteFolderModal, setDeleteFolderModal, deleteFolderInput, setDeleteFolderInput, handleDeleteFolder } = data;

	return (
		<Modal show={deleteFolderModal.status}>
			<ModalHeading heading={t('screens.fileExchange.deleteFolderTitle', { name: deleteFolderModal.folder.name })} />
			{loading ? (
				<DeleteModalSkeleton />
			) : (
				<ModalForm style={{ marginBottom: '2.5rem' }}>
					<InputsSection style={{ width: '34rem' }}>
						<InputBox
							label={t('screens.fileExchange.enterToDeleteFolder', { name: deleteFolderModal.folder.name })}
							placeholder={deleteFolderModal.folder.name}
							value={deleteFolderInput.value}
							onChange={(event) => {
								setDeleteFolderInput({ value: event.target.value, error: '' });
							}}
							errorMessage={deleteFolderInput.error}
							style={{ width: '30rem' }}
						/>
						<p className='dangerText'>
							{t('screens.fileExchange.deleteFolderWarn')}
						</p>
					</InputsSection>

					<ModalButtons
						submitButtonLabel={t('screens.fileExchange.deleteFolderBtn')}
						onSubmit={handleDeleteFolder}
						cancelButtonLabel={t('screens.fileExchange.cancel')}
						onCancel={() => {
							setDeleteFolderModal({ folder: {}, status: false });
							setDeleteFolderInput({ value: '', error: '' });
						}}
					/>
				</ModalForm>
			)}
		</Modal>
	);
};

export default DeleteFolderModal;
